<div class="map-box" [class.bigModal]="!isCollapsed">
  <div class="map-main-wrapBox">
    <google-map [height]="mapHeight ? mapHeight : '500px'" width="100%" [options]="options" id="google-map"
      (mapInitialized)="onMapInit($event)">
      @for (marker of advancedMarkerPositions; track marker) {
        <map-marker [position]="marker">
        </map-marker>
      }
    </google-map>

    @if (showMapSearch) {
      <div
        class="map-search-control"
        [class.map-search-control--disabled]="controlsDisabled"
        [style.right]="mapSearchRight"
        [style.width]="mapSearchWidth"
      >
        <app-search
          [placeholder]="mapSearchPlaceholder"
          [customWidth]="'100%'"
          [searchTerm]="mapSearchTerm"
          [disabled]="controlsDisabled"
          (searchTermUpdated)="onMapSearchTermUpdated($event)"
        ></app-search>
      </div>
    }

    <!-- overlay spinner -->
    @if (isLoading || markersLoading) {
      <div class="map-loading" aria-busy="true" aria-live="polite">
        <div class="spinner-border" role="status" aria-label="Loading"></div>
      </div>
    }

    <!-- Map layer toggle -->
    @if (showMapLayerToggle && map) {
      <div class="map-layers-control" [class.map-layers-control--disabled]="controlsDisabled">
        <button type="button" class="layers-toggle-btn" (click)="toggleMapLayer()"
          [style.width]="mapLayerWidth"
          [style.height]="mapLayerHeight"
          [attr.aria-label]="currentMapType === 'roadmap' ? 'Switch to satellite view' : 'Switch to map view'">
          @if (layerPreviewUrl) {
            <img class="layers-toggle-btn__preview" [src]="layerPreviewUrl"
              [alt]="currentMapType === 'roadmap' ? 'Satellite' : 'Map'">
          }
          <span class="layers-toggle-btn__label">{{ currentMapType === 'roadmap' ? 'Satellite' : 'Map' }}</span>
        </button>
      </div>
    }
  </div>

  @if (showDropdown || canExpandMap) {
    <div class="d-flex align-items-center dropdown-and-btn">
      <div class="datelisting">
        @if (showDropdown) {
          <div class="common-drop-down dropdown">
            <button class=" btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ selectedItem }}
              <img src="assets/images-fuel/arrowDownIcon.svg" alt="" [class.rotated]="isDropdownOpen">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
              @for (item of dropdownItems; track item) {
                <li>
                  <a class="dropdown-item" (click)="onSelect(item)">{{ item }}</a>
                </li>
              }
            </ul>
          </div>
        }
      </div>
      @if (canExpandMap) {
        <div class="zoom-btn" [class.disabled]="controlsDisabled"
          (click)="controlsDisabled ? null : onExpandClick()">
          <a class="zoom-btn__basemap-btn" [routerLink]="controlsDisabled ? null : [routeLink]"
            [queryParams]="queryParams" [class.disabled]="controlsDisabled">
            @if (isCollapsed) {
              <i class="ph ph-corners-out"></i>
            }
            @if (!isCollapsed) {
              <i class="ph ph-corners-in"></i>
            }
          </a>
        </div>
      }
    </div>
  }
</div>